import type { FunctionComponent } from 'react'

import { FlowPage, H2 } from '@monthio/design-system'
import { COLORS } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import {
	ExplainerList,
	ExplainerListItem,
} from '../../../modulesTemp/general/FlowWizardUtils'
import { OverviewIllustration } from './OverviewIllustration'

const Circle = styled.div`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${COLORS.PRIMARY};
	font-size: 16px;
	font-weight: 400;
	color: ${COLORS.GREY_SCALE.WHITE};
	flex-shrink: 0;
`

const StyledExplainerListItem = styled(ExplainerListItem)`
	display: flex;
	flex-direction: row;
	gap: 16px;
`

export const HistoricalOverviewIntro: FunctionComponent<{
	onCompleted: () => void
}> = ({ onCompleted }) => {
	const { t } = useTranslation()

	return (
		<FlowPage>
			<FlowPage.Content $spacing="m">
				<FlowPage.Header
					title={t('historicalOverviewIntro-title')}
					description={t('historicalOverviewIntro-subtitle')}
					slot={<OverviewIllustration />}
				/>
				<div>
					<H2>{t('historicalOverviewIntro-explainer-title')}</H2>
					<ExplainerList>
						<StyledExplainerListItem>
							<Circle>1</Circle>
							{t('historicalOverviewIntro-explainer-1')}
						</StyledExplainerListItem>
						<StyledExplainerListItem>
							<Circle>2</Circle>
							{t('historicalOverviewIntro-explainer-2')}
						</StyledExplainerListItem>
					</ExplainerList>
				</div>
			</FlowPage.Content>
			<FlowPage.Footer
				actions={
					<FlowPage.Cta onClick={onCompleted}>
						{t('historicalOverviewIntro-button-start')}
					</FlowPage.Cta>
				}
			/>
		</FlowPage>
	)
}
